import { render } from "./ServicesDoc.vue?vue&type=template&id=73433276&scoped=true"
import script from "./ServicesDoc.vue?vue&type=script&lang=js"
export * from "./ServicesDoc.vue?vue&type=script&lang=js"

import "./ServicesDoc.vue?vue&type=style&index=0&id=73433276&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73433276"]])

export default __exports__